import { useEffect, useState } from 'react'
import Notiflix, { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { useNavigate } from 'react-router-dom'
import { FaUserPlus } from 'react-icons/fa'
import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import api from '../helpers/apiRequester'
import { getLoginUrl } from '../helpers/authConfig'
import { StatsView } from '../components/views'
import { CreateGorillaClient } from '../components/createGorillaClient'

import globalStyles from '../globals/pages.module.scss'
import Modal from '../components/reusable/modal'
import { ViewChartDataModalContent } from '../components/modalContent/viewChartDataContent'
import { DataView } from '../components/views/dataBreakdownView'

interface selectObjectProps {
    value: string
    label: string
}

function VisionLaunchHome() {
    const navigate = useNavigate()
    const [dataReady, setDataReady] = useState(false)
    const [loading, setLoading] = useState(false)
    const [overviewData, setOverviewData] = useState<any>()
    const [modalChartData, setModalChartData] = useState<any>()
    const [modalState, setModalState] = useState(false)
    const [modalTitle, setModalTitle] = useState('')
    const [modalDate, setModalDate] = useState('')
    const [showClientModal, setShowClientModal] = useState(false)

    useEffect(() => {
        if (modalChartData != null) {
            setModalState(true)
        }
    }, [modalChartData])

    useEffect(() => {
        if (!dataReady && !loading) {
            setLoading(true)
            getData()
        }
    }, [dataReady, loading])

    const getData = async () => {
        Loading.circle('Loading...')
        try {
            const apiResponse = await api({ url: '/vision-launch-leads' })
            const data = apiResponse.data
            setOverviewData(data)
            setDataReady(true)
            Loading.remove()
        } catch (error: any) {
            console.log(error)
            Loading.remove()
            if (error?.response.status == 401) {
                Report.failure('Session Timed Out', 'Please log in again to continue.', 'Okay', () => {
                    window.location.href = getLoginUrl()
                })
            } else {
                window.location.href = getLoginUrl()
            }
        }
    }

    const prepChartData = (data: any) => {
        setModalDate(data.date)
        setModalChartData(data.dataResults)
        setModalTitle(data.title)
    }

    const toggleModal = () => {
        setModalChartData(null)
        setModalTitle('')
        setModalState(false)
    }

    const toggleClientModal = () => {
        setShowClientModal(!showClientModal)
    }

    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <ViewTitle text={'Vision Launch Lead Tracker'} />
                <div>
                    {dataReady ? (
                        <>
                            <StatsView
                                stats={overviewData.stats}
                                chartData={overviewData?.chartData}
                                dataGroup={overviewData.group}
                                handleDataModal={prepChartData}
                            />
                            {/* <DataView dataType="AgentStats" data={overviewData.ats} dataViewTitle="Agent Stats" /> */}
                        </>
                    ) : (
                        <></>
                    )}
                </div>
            </MainView>

            <Modal modalState={modalState} previewModalAction={toggleModal}>
                <ViewChartDataModalContent
                    chartData={modalChartData}
                    closeModal={toggleModal}
                    chartTitle={modalTitle}
                    chartDate={modalDate}
                />
            </Modal>
        </div>
    )
}

export default VisionLaunchHome
